import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import { useRestaurant } from 'pages/restaurants/hook/useRestaurant';
import { addPhone } from 'store/apiContext/modules/restaurant/actions';

type RestaurantActionsProps = {
  handleSubmit(): void;
  tab: number;
};

const RestaurantActions: React.FC<RestaurantActionsProps> = ({ handleSubmit, tab }) => {
  const { dispatch } = useRestaurant();
  const { setDialogNew } = useRestaurant();

  function handleAddPhone() {
    dispatch(addPhone({ id: new Date().getTime(), phone: '' }));
  }

  return (
    <>
      {tab === 1 && (
        <Tooltip title="Adicionar endereço">
          <IconButton color="inherit" onClick={() => setDialogNew(true)}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}
      {tab === 2 && (
        <Tooltip title="Adicionar telefone">
          <IconButton color="inherit" onClick={handleAddPhone}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Salvar restaurante">
        <IconButton color="inherit" onClick={handleSubmit}>
          <DoneIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default RestaurantActions;
